import { Drawer, Empty, Tag } from 'antd'
import ButtonCustom from '../../../../../Components/ButtonCustom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFloppyDisk, faHome, faTrash, faUser, faXmark } from '@fortawesome/free-solid-svg-icons'
import { Select } from '../../../../../Components/CustomUi/Select'
import { SetStateAction, useState } from 'react'
import { ChecksContainer } from '../selecaoCargos'
import { Render } from '../../../../../Components/CustomUi/render'
import { Inline } from '../../../../../Components/CustomUi/inline'
import { SelectMulti } from '../../../../../Components/CustomUi/SelectMulti'
import { HeaderTable } from '../../../../../Components/CustomUi/table/headerTable'
import { BodyTable } from '../../../../../Components/CustomUi/table/bodyTable'
import { RowTable } from '../../../../../Components/CustomUi/table/rowTable'
import { RowItem } from '../../../../../Components/CustomUi/table/rowItem'
import Carregando from '../../../../../Components/CustomUi/loading'
import { Switcher } from '../../../../../Components/CustomUi/Switcher'
import { ItensPerUserLogged } from '../../../../../services/login/permissaoUsuarioLoado'

interface PropsFormularioAtribuicao {
  openGaveta: boolean
  fecharGaveta: Function
  editar: boolean
  loadingSalvar: boolean
  cadastrar: Function
  listar_equipe: any[]
  listar_cargos: any[]
  equipe_selecionado: string
  setEquipe_selecionado: React.Dispatch<React.SetStateAction<string>>
  setEquipe_selecionado_id: React.Dispatch<React.SetStateAction<number>>
  selecionados_add: string[] | number[]
  setSelecionados_add: React.Dispatch<React.SetStateAction<string[] | number[]>>
  selecionados_add_propriedade: { descr: string; id: number; key?: number }[]
  setSelecionados_add_propriedade: React.Dispatch<
    React.SetStateAction<{ descr: string; id: number; key?: number }[]>
  >
  marcar_todos_add: boolean
  setMarcar_todos_add: React.Dispatch<React.SetStateAction<boolean>>
  setRemovidos: React.Dispatch<React.SetStateAction<any[]>>
  marcar_todos_add_propriedade: boolean
  setMarcar_todos_add_propriedade: React.Dispatch<React.SetStateAction<boolean>>
  setRemovidos_propriedade: React.Dispatch<React.SetStateAction<any[]>>
  listaDisponiveis: Function
  listaDisponiveisPropriedade: any[]
  salvarAlteracao: Function
  propriedade_selecionada_id: number
  cargos_adicionados: any[]
  loadingTable: boolean
  remover: Function
  permissions: ItensPerUserLogged
}

const FormularioAtribuicao: React.FC<PropsFormularioAtribuicao> = ({
  openGaveta,
  fecharGaveta,
  editar,
  loadingSalvar,
  cadastrar,
  listar_equipe,
  listar_cargos,
  equipe_selecionado,
  setEquipe_selecionado,
  setEquipe_selecionado_id,
  selecionados_add,
  setSelecionados_add,
  marcar_todos_add,
  setMarcar_todos_add,
  setRemovidos,
  selecionados_add_propriedade,
  setSelecionados_add_propriedade,
  marcar_todos_add_propriedade,
  setMarcar_todos_add_propriedade,
  setRemovidos_propriedade,
  listaDisponiveis,
  listaDisponiveisPropriedade,
  salvarAlteracao,
  propriedade_selecionada_id,
  cargos_adicionados,
  loadingTable,
  remover,
  permissions
}) => {
  const [openEquipe, setOpenEquipe] = useState<boolean>(false)
  const [openPropriedade, setOpenPropriedade] = useState<boolean>(false)
  

  return (
    <div>
      <Drawer
        width={700}
        open={openGaveta}
        onClose={() => fecharGaveta()}
        closable={false}
        bodyStyle={{ padding: 0, overflowX: 'hidden' }}
        headerStyle={{ padding: '10px 10px' }}
        destroyOnClose
        title={
          <div
            style={{ display: 'flex', flexDirection: 'column', gap: 5, justifyContent: 'center' }}
          >
            <div
              style={{
                width: '100%',
                height: 35,
                borderBottom: 'thin solid var(--border-color)',
                marginLeft: -22,
              }}
            >
              <ButtonCustom
                onClick={fecharGaveta}
                type='tertiary'
                danger
                style={{ marginLeft: 10, marginTop: -10 }}
                icon={<FontAwesomeIcon icon={faXmark} />}
              >
                Fechar
              </ButtonCustom>
            </div>

            <>{editar ? 'Atualizar atribuição' : 'Cadastrar atribuição'}</>
          </div>
        }
        footer={
          <ButtonCustom
            disabled={loadingSalvar}
            loading={loadingSalvar}
            icon={<FontAwesomeIcon icon={faFloppyDisk} />}
            onClick={cadastrar}
          >
            {editar ? 'Atualizar' : 'Salvar'}
          </ButtonCustom>
        }
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            padding: 10,
            boxSizing: 'border-box',
            gap: '10px',
          }}
        >
          <Select
            label='Membro equipe'
            placeholder='Selecione um membro da equipe'
            value={equipe_selecionado}
            onChange={setEquipe_selecionado}
            onChangeID={setEquipe_selecionado_id}
            open={openEquipe}
            trigger={setOpenEquipe}
            items={listar_equipe}
            descricaoItem={'usuario_nome'}
            idItem={'cod_func'}
            disabled={editar}
            icon={faUser}
          />

          <Switcher
            label='Marcar todas propriedade'
            isChecked={marcar_todos_add_propriedade}
            trigger={setMarcar_todos_add_propriedade}
            size='small'
          />

          <SelectMulti
            label='Propriedades'
            icon={faHome}
            placeholder='Selecione a propriedade'
            open={openPropriedade}
            trigger={setOpenPropriedade}
            items={listaDisponiveisPropriedade}
            descricaoItem={'nome'}
            idItem={'cod'}
            selecteds={selecionados_add_propriedade}
            onChange={setSelecionados_add_propriedade}
          />

          <ChecksContainer
            title='Cargos'
            height={'calc(100vh - 275px)'}
            width={'100%'}
            items={listaDisponiveis()}
            descriptionItem={'nome'}
            targetItem={'cod'}
            selecteds={selecionados_add}
            selectItens={setSelecionados_add}
            setRemovidos={setRemovidos}
            emptyMessage='Nenhum cargo disponível'
            loadingMessage='Carregando cargos...'
            isLoading={false}
            isLoadingBtn={false}
            markAll={marcar_todos_add}
            setMarkAll={setMarcar_todos_add}
            onChange={() => salvarAlteracao()}
            editar={true}
          />

          {/* <ChecksContainer
                title='Propriedades'
                height={'calc(100vh - 275px)'}
                width={'100%'}
                items={listaDisponiveisPropriedade}
                descriptionItem={'nome'}
                targetItem={'cod'}
                selecteds={selecionados_add_propriedade}
                selectItens={setSelecionados_add_propriedade}
                setRemovidos={setRemovidos_propriedade}
                emptyMessage='Nenhuma propriedade disponível'
                loadingMessage='Carregando propriedades...'
                isLoading={false}
                isLoadingBtn={false}
                markAll={marcar_todos_add_propriedade}
                setMarkAll={setMarcar_todos_add_propriedade}
                onChange={() => salvarAlteracao('add')}
                editar={true}
              /> */}
        </div>
      </Drawer>
    </div>
  )
}

export default FormularioAtribuicao